<div class="row form-row">
    <div class="col-12 p-3">
        <p class="text-start pt-2 pb-2">{{ (label() + ".wantToCancel") | translate}}</p>
        <div class="form-group text-start" *ngIf="isMandatoryJustification()">
          <label for="justification">{{ ("scheduling.cancelDescription")  | translate }}:</label>
          <div class="input-group">
            <textarea
              id="justification"
              class="form-control"
              (input)="onDescriptionChanged($event)"></textarea>
            <div *ngIf="isMandatoryJustification() && currentDescription === ''" class="invalid-feedback d-block mt-2">
              <div>
                {{ ('errors.cancelDescriptionRequired') | translate }}
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <app-close-button
        (onCloseClicked)="onClose()">
      </app-close-button>
      <app-cancel-button
        *ngIf="!isMandatoryJustification() || (isMandatoryJustification()  && currentDescription !== '')"
        (onCancelClicked)="onCancel()">
      </app-cancel-button>
    </div>
</div>
